<template>
    <div class="subject-area-banner" :style="cssVars">
        <div class="subject-area-banner__content -wrap">
            <TotemIntro type="image" isSubjectAreaBanner>
                <template #title>
                    <span v-html="mainPackageHeadline.title"></span>
                </template>
                <template #description v-if="!hideDescription">
                    <span v-html="mainPackageHeadline.description"></span>
                </template>
                <template #image>
                    <div class="intro__image-box">
                        <img :src="imageUrl" alt="" v-if="imageExists" />
                    </div>
                </template>
            </TotemIntro>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'

    export default {
        name: 'subject-area-banner',
        props: {
            mainPackageHeadline: {
                type: Object
            }
        },
        data () {
            return {
                imageUrl: '',
                imageExists: false
            }
        },
        computed: {
            ...mapGetters({
                mainPackage: 'Search/selectedMainPackage',
                categories: 'Menu/getCategories',
                notificationHeight: 'getNotificationHeight'
            }),
            cssVars () {
                if (this.notificationHeight !== 0) {
                    return {
                        '--top': this.notificationHeight + 'px',
                        '--margin-bottom': this.notificationHeight + 'px'
                    }
                }

                return {
                    '--top': '-80px',
                    '--margin-bottom': '-80px'
                }
            },
            hideDescription () {
                return ['no-eduhouse-internal', 'no-gpa'].includes(this.mainPackage)
            }
        },
        created () {
            const imagePath = require(`@/assets/images/subject-area-banner/${this.mainPackage}.png`)
            this.imageUrl = imagePath

            const img = new Image();
            img.onload = () => {
                this.imageExists = true
            };
            img.onerror = () => {
                this.imageExists = false
            };
            img.src = imagePath
        }
    }
</script>

<style lang="scss" scoped>
    .subject-area-banner {
        background: $light_blue;
        display: flex;

        [class*="desktop"] & {
            position: relative;
            padding: 80px 0 0 0;
            height: 506px;
            top: var(--top);
            margin-bottom: var(--margin-bottom);
        }

        &__title {
            font-family: PPAgrandir-Medium, sans-serif;
            font-size: 4.8rem;
            color: $lavender;
            margin: 0 0 20px;
        }

        &__description {
            font-family: PlusJakartaSans-Medium, sans-serif;
            font-size: 2.2rem;
            color: $tuatara;
            line-height: 130%;
        }
    }
</style>
